<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<section class="selector-modal">
			<div class="selector-modal__header">
				<div>
					<h4 class="selector-modal__title">Búsqueda de {{ ProveedorMode ? "proveedores" : "clientes" }}</h4>
					<p class="selector-modal__subtitle">Busque y seleccione {{ ProveedorMode ? "un proveedor" : "un cliente" }} para el documento.</p>
				</div>
			</div>
			<div class="selector-modal__filters">
				<app-search-bar class="selector-modal-search" [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" (busqueda)="searchElementsByFilter($event)" [filtroPaisInline]="InternationalMode" [insideModal]="true"></app-search-bar>
			</div>
	<div class="selector-modal__body">
		<div class="selector-modal__toolbar">
			<span class="text-muted">Seleccione una fila para usar sus datos.</span>
			<label class="selector-modal__page-size">Mostrar
				<select class="form-control form-control-sm" [ngModel]="page.pageSize" (ngModelChange)="cambiarTamanoPagina($event)" [disabled]="loading">
					<option [ngValue]="10">10</option><option [ngValue]="25">25</option><option [ngValue]="50">50</option>
				</select> por página
			</label>
		</div>
		<div class="selector-modal__table table-responsive" [attr.aria-busy]="loading">
			<table class="table mb-0" [attr.aria-label]="ProveedorMode ? 'Proveedores disponibles' : 'Clientes disponibles'">
				<thead><tr>
					<th scope="col">{{ InternationalMode ? 'Identificador' : 'RUT' }}</th>
					<th scope="col">Razón social</th>
					<th scope="col" *ngIf="!ProveedorMode && !InternationalMode">Datos</th>
					<th scope="col" *ngIf="!ProveedorMode && !InternationalMode">Dirección y correo</th>
					<th scope="col" *ngIf="InternationalMode">País</th>
				</tr></thead>
				<tbody *ngIf="!loading">
					<tr *ngFor="let row of rowsMantenedor" class="selector-modal__selectable" (click)="onActivate({ type: 'click', row: row })">
						<td><button type="button" class="selector-modal__select-button">{{ InternationalMode ? row.codigoInterno : ProveedorMode ? row.rutProveedor : row.rutString }}</button></td>
						<td>{{ row.razonSocial || '—' }}<small class="d-block text-muted" *ngIf="row.nombreFantasia">{{ row.nombreFantasia }}</small></td>
						<td *ngIf="!ProveedorMode && !InternationalMode">{{ row.clienteId ? 'Datos guardados' : 'Datos base' }}</td>
						<td *ngIf="!ProveedorMode && !InternationalMode">{{ row.dirFact || 'Sin dirección' }}<small class="d-block">{{ row.correoFact || 'Sin correo' }}</small></td>
						<td *ngIf="InternationalMode">{{ row.nombrePais }}</td>
					</tr>
					<tr *ngIf="rowsMantenedor.length === 0"><td [attr.colspan]="InternationalMode ? 3 : ProveedorMode ? 2 : 4" class="selector-modal__empty">No hay resultados para estos filtros.</td></tr>
				</tbody>
				<tbody *ngIf="loading"><tr><td [attr.colspan]="InternationalMode ? 3 : ProveedorMode ? 2 : 4" class="selector-modal__empty" role="status">Cargando…</td></tr></tbody>
			</table>
		</div>
		<div class="selector-modal__pagination">
			<span class="text-muted" aria-live="polite">{{ page.totalElements }} {{ ProveedorMode ? 'proveedores' : 'clientes' }}</span>
			<ngb-pagination [collectionSize]="page.totalElements" [page]="page.pageNumber + 1" [pageSize]="page.pageSize"
				[maxSize]="5" [rotate]="true" [boundaryLinks]="true" [disabled]="loading" size="sm"
				(pageChange)="setPage({ offset: $event - 1 })" aria-label="Páginas de clientes">
			</ngb-pagination>
		</div>
	</div>
</section>
